import React, { useEffect } from 'react';
import { Switch, FormControlLabel, Typography, Grid, Box } from '@mui/material';
import { useLanguage } from './LanguageContext';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export default function LanguageSwitcher() {
  const { language, switchLanguage } = useLanguage();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [checked, setChecked] = React.useState(language === 'en');

  // Synchronize state with context
  useEffect(() => {
    setChecked(language === 'en');
  }, [language]);

  const handleChange = (event) => {
    setChecked(event.target.checked);
    switchLanguage(event.target.checked ? 'en' : 'de');
  };

  return (
    <Typography component="div">
      <Box
        sx={{
          position: 'fixed',
          bottom: mobile ? 60 : 100,
          right: 15,
          pl: 2,
          pr: 2,
          bgcolor: '#65C18C',
          borderRadius: '3px',
          display: 'inline-block',
          zIndex: 1000,
          '& > *': { opacity: 1 },
        }}
      >
        <Grid component="label" container alignItems="center" spacing={1}>
          <Grid item sx={{ color: 'black' }}>DE</Grid>
          <Grid item>
            <FormControlLabel
              control={
                <Switch
                  checked={checked}
                  onChange={handleChange}
                  name="checked"
                  sx={{
                    '& .MuiSwitch-thumb': { color: 'black' },
                    '& .MuiSwitch-switchBase.Mui-checked': {
                      color: 'black',
                      '& + .MuiSwitch-track': { backgroundColor: '#bfbfbf' },
                    },
                  }}
                />
              }
              label=""
              style={{ marginRight: -9 }}
            />
          </Grid>
          <Grid item sx={{ color: 'black' }}>EN</Grid>
        </Grid>
      </Box>
    </Typography>
  );
}